<!-- <span nz-tooltip [nzTooltipTitle]="text">
  <i nz-icon nzType="question-circle" nzTheme="outline" style="margin: 0 10px 0 2px;"></i>
</span> -->

<span nz-tooltip [nzTooltipTitle]="titleTemplate">
  <i nz-icon nzType="question-circle" nzTheme="outline" style="margin: 0 10px 0 2px;color: #1790ff;"></i>
  <ng-template #titleTemplate>
    <div class="white_space_zhushi">
      {{ text }}
    </div>
  </ng-template>
</span>
